// removed by extract-text-webpack-plugin
module.exports = {"page_buy":"app__css__app-pages-SelfHelp-education-__index__page_buy"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/SelfHelp/education/index.css
// module id = 1569
// module chunks = 0